import request from '@/utils/request'

// 查询列表
export function apiScpMrpWipDemandKittingList (query) {
  return request({
    url: '/scp/scpMrpWipDemandKitting/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiScpMrpWipDemandKittingNewExport (data) {
  return request({
    url: '/scp/scpMrpWipDemandKitting/v2/export',
    method: 'post',
    data: data
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansKittingExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/kittingExecutionTime',
    method: 'get',
    params: query
  })
}
